// EventSlider.jsx
import React, { useEffect, useRef, useState } from 'react';
import styles from './eventSlider.module.css';
import { RenderIf } from 'utilities/helpers';
import { Ikon } from 'assets/icons';
import { Column, Row } from 'layouts/container';

const events = [
  {
    date: 'DEC 14, 2024',
    title: 'Pakistan vs India Cricket Match',
    spike: '15%',
    previous: '16.4%',
  },
  {
    date: 'DEC 14, 2024',
    title: 'Rainy Weather',
    spike: '15%',
    previous: '16.4%',
  },
  {
    date: 'DEC 14, 2024',
    title: 'Christmas Holiday',
    spike: '15%',
    previous: '16.4%',
  },
  {
    date: 'DEC 14, 2024',
    title: 'Rainy Weather',
    spike: '15%',
    previous: '16.4%',
  },
  {
    date: 'DEC 14, 2024',
    title: 'Christmas Holiday',
    spike: '15%',
    previous: '16.4%',
  },
];

const EventSlider = () => {
  const scrollRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);

  const scrollRight = () => {
    scrollRef.current.scrollBy({
      left: 300,
      behavior: 'smooth',
    });
  };
  const scrollLeft = () => {
    scrollRef.current.scrollBy({
      left: -300,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        setIsScrolled(scrollRef.current.scrollLeft > 100);
      }
    };

    const refCurrent = scrollRef.current;
    if (refCurrent) {
      refCurrent.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <div className={styles.sliderContainer}>
        <RenderIf isTrue={isScrolled}>
            <button className={styles.scrollButton} onClick={() => { scrollLeft(); }}>
                <Ikon name={`event-slider-prev`} />
            </button>
        </RenderIf>
        <div className={styles.sliderContent}>
            <div className={styles.cardList} ref={scrollRef}>
                {events.map((event, index) => (
                <div className={styles.eventCard} key={index}>
                    <p className={styles.date}>{event.date}</p>
                    <h3 className={styles.title}>{event.title}</h3>
                    <Row gap={10} alignItems={'center'}>
                        <p className={styles.spike}>EXP. DEMAND SPIKE</p>
                        <div className={styles.badge}>
                            <Ikon name={`event-card-chart`} /> {event.spike}
                        </div>
                    </Row>
                    <Row gap={8} alignItems={'center'}>
                        <div className={styles.leftBorder}></div>
                        <Column gap={5}>
                            <p className={styles.previous}>
                                Previous similar event
                            </p>
                            <div className={styles.previousGreen}>
                                <span className={styles.upAro}>▲</span>
                                {event.previous}
                            </div>
                        </Column>
                    </Row>
                </div>
                ))}
            </div>
        </div>
        <button className={styles.scrollButton} onClick={() => { scrollRight(); }}>
            <Ikon name={`event-slider-next`} />
        </button>
    </div>
  );
};

export default EventSlider;
